import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import Tooltip from '../Tooltip'

import './Point.scss'

import points from './points'

const CLASS = 'insights-portal-point'

const Point = props => {
  const className = `${CLASS}${props.className ? ` ${props.className}` : ''}`
  const ref = useRef()
  const content = props.tipName && points[props.tipName] ? points[props.tipName] : props.content
  return props.inline ? (
    <span ref={ref} tabIndex={0} className={className} disabled={props.disabled}>
      {props.children || '?'}
      <Tooltip onTarget={() => ref.current} content={content} hideOn={props.hideOn} showOn={props.showOn} />
    </span>
  ) : (
    <div ref={ref} tabIndex={0} className={className} disabled={props.disabled}>
      {props.children || '?'}
      <Tooltip onTarget={() => ref.current} content={content} hideOn={props.hideOn} showOn={props.showOn} />
    </div>
  )
}

Point.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  inline: PropTypes.any,
  content: PropTypes.any,
  tipName: PropTypes.string,
  showOn: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  hideOn: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  disabled: PropTypes.any,
  onClick: PropTypes.func
}

export default Point
